'use client';

import type { ReactNode } from 'react';

/**
 * Component to handle error in sportinfo page.
 *
 * @returns error message
 */
export default function SportinfoError(): ReactNode {
  return 'Tyvärr går det inte att visa statistiken för tillfället';
}
